export function formatUserFullName(firstName, lastName, email) {
  const fn = String(firstName || "").trim();
  const ln = String(lastName || "").trim();
  const full = [fn, ln].filter(Boolean).join(" ");
  if (full) return full;
  const em = String(email || "").trim();
  return em.split("@")[0] || em || "";
}

export function initialsFromProfile(email, firstName, lastName, fallbackLabel) {
  const fn = String(firstName || "").trim();
  const ln = String(lastName || "").trim();
  if (fn && ln) return `${fn[0]}${ln[0]}`.toUpperCase();
  if (fn.length >= 2) return fn.slice(0, 2).toUpperCase();
  const d = String(fallbackLabel || "").trim();
  if (d.length >= 2) return d.slice(0, 2).toUpperCase();
  const local = String(email || "").split("@")[0] || "";
  if (local.length >= 2) return local.slice(0, 2).toUpperCase();
  return (local.slice(0, 1) || "?").toUpperCase();
}
